import { preactConnectStore } from 'common/module/preact/connect-store';
import { SaveSearchFormPropsInterface } from 'common/module/save-search/form/props.interface';
import { SaveSearchFormViewStore } from 'common/module/save-search/form/view-store';
import { SaveSearchFormViewStoreFactory } from 'common/module/save-search/form/view-store.factory';

import { SaveSearchFormTemplate } from './template';

export const SaveSearchFormComponent = preactConnectStore<
  SaveSearchFormViewStore,
  SaveSearchFormPropsInterface,
  Partial<SaveSearchFormPropsInterface>
>(
  SaveSearchFormViewStoreFactory,
  (store) => store.getState(),
  (store, { props }) => store.initialize(props)
)(SaveSearchFormTemplate);
